// @flow
import L from 'leaflet';
import { get } from 'lodash';
import { LAT_LNG_MAX_MARGIN } from 'esm-web-pro/containers/pages/network/Util';

const UseHighlightPolygon = (coordinates: Array<[number, number]>, [style: Object, reverseStyle: Object]) => {
    let highlightedLayer;

    return {
        run: (layer) => {
            if (!(get(layer, 'feature.geometry.type') === 'Polygon')) return;
            if (L.latLngBounds(coordinates).equals(layer.getBounds(), LAT_LNG_MAX_MARGIN)) {
                highlightedLayer = layer;
                layer.setStyle(style);
                if (layer._path) {
                    L.DomUtil.addClass(layer._path, layer.options.className);
                }
            }
        },

        cleanUp: () => {
            if (highlightedLayer) {
                highlightedLayer.setStyle(reverseStyle);
            }
        },
    };
};

export default UseHighlightPolygon;
